import { EmailLink, IColumn, WhatsAppLink } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeStudentsNoAppUsageColumns = (): IColumn[] => {
  const { getLegends } = useLegends();
  return [
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 270,
      cellRenderer: ({ rowData }) => (
        <div className="d-flex flex-column">
          <span>
            <strong>{rowData?.student}</strong>
          </span>
          <span style={{ fontWeight: 'lighter' }}>{rowData?.cpf}</span>
        </div>
      ),
    },
    {
      title: 'Telefone',
      dataKey: 'phone',
      cellRenderer: ({ rowData }) => {
        return rowData?.phone ? (
          <WhatsAppLink telephone={rowData?.phone} />
        ) : (
          <></>
        );
      },
    },
    {
      title: 'Email',
      dataKey: 'email',
      width: 200,
      cellRenderer: ({ cellData, rowData }) => {
        console.log(cellData, rowData);
        return rowData?.phone ? <EmailLink email={rowData?.email} /> : <></>;
      },
    },
    {
      title: getLegends('GRUPO', false),
      dataKey: 'group',
      width: 270,
    },
  ];
};
